import React from 'react';
    import { motion } from 'framer-motion';
    import { useAuth } from '../../context/AuthContext';
    import SafeIcon from '../../common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';

    const { FiInstagram, FiLogOut, FiHome } = FiIcons;

    const AdminHeader = () => {
      const { signOut } = useAuth();

      const handleSignOut = async () => {
        await signOut();
      };

      return (
        <motion.header
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white border-b border-gray-200 sticky top-0 z-50"
        >
          <div className="container mx-auto px-4 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <img src="https://folder.host/images/2025/11/16/clink-logo.png" alt="Chaldean Link Logo" className="h-10 w-auto" />
                
              </div>
              <div className="flex items-center space-x-4">
                <a href="#/" className="flex items-center space-x-2 text-gray-600 hover:text-yellow-500 transition-colors">
                  <SafeIcon icon={FiHome} className="text-lg" />
                  <span>View Site</span>
                </a>
                <button
                  onClick={handleSignOut}
                  className="flex items-center space-x-2 text-gray-600 hover:text-red-600 transition-colors"
                >
                  <SafeIcon icon={FiLogOut} className="text-lg" />
                  <span>Sign Out</span>
                </button>
              </div>
            </div>
          </div>
        </motion.header>
      );
    };

    export default AdminHeader;